var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.iconName,_vm._b({tag:"component",class:['icons', 'base-icons', ("icons-" + _vm.iconName)],style:({fontSize: _vm.iconSize, color: _vm.iconColor}),attrs:{"color":_vm.iconColor}},'component',_vm.svgAttrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }